const formatPercentage = (value, fractionDigits) => {
  if (isNaN(value)) return '0%'
  return new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(value)
}

export { formatPercentage }
